module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"learn_more":"Learn More","title":"Add deployment","headline":"This wizard guides you through creating a new deployment.","content":"Deployments enable multi-tenant isolation, allowing you to separate and manage your Unryo systems independently."}}')
  delete Component.options._Ctor
}
